import { render } from "./PasswordReset.vue?vue&type=template&id=7a7e161e"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"
script.render = render

export default script